interface SchoolCardProps {
  title: string;
  imageSrc: string;
  onClick?: () => void;
  disabled?: boolean;
}

export const SchoolCardImg: React.FC<SchoolCardProps> = ({ title, imageSrc,onClick, disabled = false }) => {
  function handleClick() {
    if (!disabled && onClick) {
      onClick();
    }
  }
  return (
    <div
      onClick={handleClick}
      className={`${
        disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer transform transition duration-300 hover:scale-105'
      } flex flex-col items-center justify-center w-[calc(50%-0.375rem)] max-w-[150px] sm:w-56 sm:max-w-none gap-y-4 p-4 sm:p-6 md:p-8 rounded-3xl border-b-4 border-fpcred shadow-lg bg-white select-none`}>
      <img
        className={`w-20 h-20 sm:w-24 sm:h-24 object-contain mb-2`}
        src={imageSrc}
        alt={`Immagine della ${title}`}
      />
      <div className="text-center">
        <p className="font-bold text-lg sm:text-xl md:text-2xl">{title}</p>
      </div>
    </div>
  );
};
